export default __webpack_public_path__ + "static/media/receipt.d74dde96.svg";